import * as React from "react";
import ShiftCodeList from "../../presentations/ShiftCodeList";

const ShiftCodeListContainer = (props: any) => {

  const { onEdit } = props;

  const handleOnEdit = (rowData: any) => {
    console.log('on edit group list container ---');
    console.log(rowData);
    onEdit(rowData);
  }

  return (
    <div>
      <ShiftCodeList onEdit={handleOnEdit}></ShiftCodeList>
    </div>
  );
};

export default ShiftCodeListContainer;
